import { Accordion, Toggle, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GiftListModal, ThankYouEmailsModal, UnwrapModal } from '@hero/components/modals';
import { configs } from '@hero/configs';
import { DetailItem } from '@hero/molecules';
import { useGetUser } from '@hero/services/organization-service/hooks';

import * as S from './style';
function OverviewAdvanceSettings({ advanceSettings, setAdvanceSettings, disabled, style }) {
  const { t } = useTranslation();
  const [showGiftListInfoModal, setShowGiftListInfoModal] = useState(false);
  const [showUnwrapModal, setShowUnwrapModal] = useState(false);
  const [showThankYouModal, setShowThankYouModal] = useState(false);

  const { settings: { onlyCollectAddress, disableScratchEffect, receiveThankYouNotes } = {} } =
    advanceSettings;
  const { data: userData } = useGetUser();

  return (
    <S.OverviewAdvanceSettingsWrapper>
      <Accordion title={t('advancedSettings')} style={style}>
        {configs.advanceSettings.scratchEffectEnabled && (
          <DetailItem
            title={`${t('unwrapEffect')}:`}
            className="item-d-flex"
            titleIcon
            titleIconOnClick={() => setShowUnwrapModal(true)}
          >
            <Typography variant="body2" color="neutral" emphasis="500" fontWeight="400">
              {t('advanceSettingsDetailItem1Desc')}
            </Typography>
            <Toggle
              checked={!disableScratchEffect}
              disabled={disabled}
              onChange={async () => {
                setAdvanceSettings({
                  settings: {
                    ...advanceSettings?.settings,
                    disableScratchEffect: !disableScratchEffect
                  }
                });
              }}
            />
            <UnwrapModal isOpen={showUnwrapModal} setIsOpen={setShowUnwrapModal} />
          </DetailItem>
        )}
        <DetailItem
          title={`${t('thankYouEmails')}`}
          className="item-d-flex"
          titleIcon
          titleIconOnClick={() => setShowThankYouModal(true)}
        >
          <Typography variant="body2" color="neutral" emphasis="500" fontWeight="400">
            {t('thankYouEmailsDescription')}
          </Typography>
          <Toggle
            checked={receiveThankYouNotes}
            disabled={disabled}
            onChange={async () => {
              setAdvanceSettings({
                settings: {
                  ...advanceSettings?.settings,
                  receiveThankYouNotes: !receiveThankYouNotes
                }
              });
            }}
          />
          <ThankYouEmailsModal
            isOpen={showThankYouModal}
            onRequestClose={() => {
              setShowThankYouModal(false);
            }}
            senderName={userData?.firstName || t('sender')}
          />
        </DetailItem>
        {configs.advanceSettings.onlyCollectAddressEnabled && (
          <DetailItem
            title={t('advanceSettingsDetailItem3Title')}
            titleIcon
            className="item-d-flex"
            titleIconOnClick={() => setShowGiftListInfoModal(true)}
          >
            {t('advanceSettingsDetailItem3Desc')}
            <Toggle
              checked={onlyCollectAddress}
              disabled={disabled}
              onChange={() => {
                setAdvanceSettings({
                  settings: {
                    ...advanceSettings?.settings,
                    onlyCollectAddress: !onlyCollectAddress
                  }
                });
              }}
            />
            <GiftListModal isOpen={showGiftListInfoModal} setIsOpen={setShowGiftListInfoModal} />
          </DetailItem>
        )}
      </Accordion>
    </S.OverviewAdvanceSettingsWrapper>
  );
}

OverviewAdvanceSettings.propTypes = {
  advanceSettings: PropTypes.shape({
    settings: PropTypes.shape({
      onlyCollectAddress: PropTypes.bool,
      disableScratchEffect: PropTypes.bool,
      receiveThankYouNotes: PropTypes.bool
    })
  }),
  setAdvanceSettings: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.object
};

export { OverviewAdvanceSettings };
